import * as internals from './internals.js';

const warnedAboutDefault = new WeakSet();

const UsesFeatureFlags = {
    inject: {
        featureEnabled: {
            from: internals.FEATURE_ENABLED_KEY,
            default() {
                return () => {
                    warnAboutDefault(this);
                    return false;
                };
            }
        }
    }
};

/**
 * Set this to 'false' to disable warnings when there is no FeatureFlagApp in the tree of
 * above a component which mixes in UsesFeatureFlags.
 */
UsesFeatureFlags.logMissingAppComponent = internals.warningsEnabledByDefault;

export default UsesFeatureFlags;

/* istanbul ignore next */
function warnAboutDefault(self) {
    if (warnedAboutDefault.has(self) || !UsesFeatureFlags.logMissingAppComponent) {
        return;
    }
    warnedAboutDefault.add(self);
    console.warn(
        '[ns-feature-flags-vue] UsesFeatureFlags is being used outside of a root <FeatureFlagApp>.',
        'All flags will be assumed to be disabled.\n',
        internals.getComponentTree(self),
        '\n(to disable this warning, set UsesFeatureFlags.logMissingAppComponent = false)'
    );
}
